import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase';
import "./introduction.css"
import 'animate.css';

const Introduction = () => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "content"));
        if (!querySnapshot.empty) {
          // Assuming there is only one document in the 'content' collection
          setContent(querySnapshot.docs[0].data());
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching introduction content:", error);
        setLoading(false);
      }
    };

    fetchContent();
  }, []);

  const handleNavClick = (event, anchorId) => {
    event.preventDefault();
  
    const scrollToElement = document.getElementById(anchorId);
    if (scrollToElement) {
      const offset = window.innerWidth <= 800 ? -96 : 0; 
      const elementPosition = scrollToElement.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition + offset;
  
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  };

  if (loading || !content) return null; // Prevents layout shift while loading

  return (
    <section id='introduction'>
      <div className='intro'>
          {/* Dynamic Profile Image from Firebase Storage URL */}
          <img src={content.image_url} className='intro_img' alt={content.name}></img>
          
          <div className='intro_text'>
            <p className='intro_text_line' style = {{color:"#696984", }}>Hi, My name is</p>
            
            {/* Dynamic Name */}
            <p className='intro_text_lines animate__animated animate__bounceIn'>
                {content.name}
            </p>
            <p className='intro_designation'>
                {content.designation}
            </p>
            
            {/* Dynamic Bio Line 1 */}
            <p style={{
                fontSize:"18px", 
                color:"#696984", 
                marginTop:"-45px", 
                overflowWrap: "break-word",
                textAlign:"center" 
            }}>
                {content.desc1}
            </p>
            
            {/* Dynamic Bio Line 2 */}
            <p style={{
                fontSize:"18px", 
                color:"#696984", 
                marginTop:"-5px",
                overflowWrap: "break-word", 
                textAlign:"center" 
            }}>
                {content.desc2}
            </p>
            <p style={{
                fontSize:"12px", 
                color:"black", 
                marginTop:"-5px",
                overflowWrap: "break-word", 
                textAlign:"center", 
                fontStyle:'italic',
            }}>
                {content.sign_off}
            </p>
            <p 
                style={{
                    fontSize: "12px", 
                    color: "black", 
                    marginTop: "-5px",
                    overflowWrap: "break-word", 
                    textAlign: "center", 
                    fontStyle: 'italic',
                }}
            >
                <span 
                    onClick={() => window.open(content.disclaimer_link, "_blank", "noopener,noreferrer")}
                    style={{
                        cursor: "pointer",
                        textDecoration: "underline",
                        color: "#007bff" // Standard blue link color, or keep "black" if preferred
                    }}
                    onMouseOver={(e) => e.target.style.color = "#0056b3"}
                    onMouseOut={(e) => e.target.style.color = "#007bff"}
                >
                    {content.disclaimer_link}
                </span>
            </p>
            
            <a href="#contact" onClick={(e) => handleNavClick(e, 'contact')} className='intro_text_button' style={{textDecoration: 'none'}}>CONTACT ME</a>
          </div>
      </div>
    </section>
  )
}

export default Introduction